interface IParams {
  section: string;
  subdomain: string;
  isNewFilters: boolean;
}

export const shouldNewFiltersShow = ({ section, subdomain, isNewFilters }: IParams) =>
  section !== 'new-buildings' && ['nn', 'kazan'].includes(subdomain) && isNewFilters;
